import Dexie from "dexie";
import db from "../Db";

var DeleteDuree = Dexie.async(function* () {
  yield db.open();
  yield db.DUREE.clear();
});

export default DeleteDuree;
